import { PASSWORD_STATUS_TEXT } from 'src/services/gigya/constants';
import { Notification } from 'src/types';

export const mapErrorCodeToNotificationParams = (
  errorCode: number
): { title: Notification['title']; variant: Notification['variant'] } => {
  if (errorCode === 0) {
    return {
      title: PASSWORD_STATUS_TEXT['successful'],
      variant: 'success' as Notification['variant'],
    };
  } else if (errorCode === 400006 || errorCode === 401030) {
    return {
      title: PASSWORD_STATUS_TEXT['recently_used_password_error'],
      variant: 'error' as Notification['variant'],
    };
  } else if (errorCode === 403042) {
    return {
      title: PASSWORD_STATUS_TEXT['incorrect_current_password_error'],
      variant: 'error' as Notification['variant'],
    };
  } else {
    return {
      title: PASSWORD_STATUS_TEXT['internal_api_error'],
      variant: 'error' as Notification['variant'],
    };
  }
};
